import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import PersonalSupport from "@/pages/PersonalSupport";
import About from "@/pages/About";
import Packages from "@/pages/Packages";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WhatsAppButton from "@/components/WhatsAppButton";
import LegalPage from "@/pages/LegalPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-obsidian">
      <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/personal-support" element={<PersonalSupport />} />
              <Route path="/about" element={<About />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<LegalPage docKey="privacy" />} />
              <Route path="/terms-of-use" element={<LegalPage docKey="terms" />} />
              <Route path="/service-terms" element={<LegalPage docKey="service" />} />
              <Route path="/translation-disclaimer" element={<LegalPage docKey="translation" />} />
              <Route path="/website-disclaimer" element={<LegalPage docKey="website" />} />
              <Route path="/refund-policy" element={<LegalPage docKey="refund" />} />
              <Route path="/cookie-policy" element={<LegalPage docKey="cookies" />} />
              <Route path="/accessibility" element={<LegalPage docKey="accessibility" />} />
              <Route path="/newcomer-disclaimer" element={<LegalPage docKey="newcomer" />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
